module.exports = __webpack_public_path__ + "img/ridchadata_logo.db42fb02.png";